import { datadogRum } from '@datadog/browser-rum'
import { consola } from 'consola'
import { fallback, optional, picklist, pipe, string, trim } from 'valibot'

export const KNOWN_LAW_NODE_TYPES = [
  'law',
  'chapter',
  'section',
  'subsection',
  'del',
  'paragraph',
  'note',
  'content_supplement',
  'legal_commentary',
  'legal_commentary_section',
  'footnote',
] as const

export const UNKNOWN_LAW_NODE_TYPE = 'unknown'

export type LawCommentaryNodeType = typeof KNOWN_LAW_NODE_TYPES[number] | typeof UNKNOWN_LAW_NODE_TYPE

const loggedTypes = new Set<string>()

export function logUnknownLawNodeType(value: unknown): void {
  const received = typeof value === 'string' ? value : String(value)
  if (loggedTypes.has(received)) {
    return
  }

  loggedTypes.add(received)

  const logger = (import.meta.dev || import.meta.server) ? consola.error : datadogRum.addError
  logger('Unknown law nodeType', { nodeType: received })
}

// Keep the fallback value in the picklist so Valibot and `vue-tsc` accept it
const LAW_NODE_TYPES = [...KNOWN_LAW_NODE_TYPES, UNKNOWN_LAW_NODE_TYPE] as const

// Keep `optional` outside `fallback` to avoid logging missing values
export const lawNodeTypeSchema = optional(
  fallback(pipe(string(), trim(), picklist(LAW_NODE_TYPES)), (dataset) => {
    logUnknownLawNodeType(dataset?.value)
    return UNKNOWN_LAW_NODE_TYPE
  })
)